import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../Store/AuthContext";

export const CheckLanguageSelected = () => {
  const { state } = useAuth();
  const location = useLocation();

  const path = location.pathname;

  return path.includes("username") && !state.lang.code ? (
    <Navigate to={"/Signin/select-language"} />
  ) : path.includes("language") && state.lang.code && state.lang.cookie ? (
    <Navigate to={"/Signin/enter-username"} />
  ) : (
    <Outlet />
  );
};
